import { useQuery } from '@tanstack/react-query'
import { fetchContacts } from '../queries/contacts.queries'

export const useContacts = () =>
  useQuery({
    queryKey: ['contacts'],
    queryFn: fetchContacts,
  })
